/**
 * DiscoveryContext (AJIP-16.02.005 · WS7)
 * ---------------------------------------------------------------------
 * Framework-agnostic input contract. Pure JS. No React/Redux/Zustand
 * imports. Strict validation with data-minimisation guardrails.
 */
import { InvalidDiscoveryContextError } from './RegistrationDiscoveryErrors';

const PROHIBITED_KEYS = Object.freeze([
  'password', 'token', 'apiKey', 'secret', 'credential',
  'cardNumber', 'cvv', 'privateKey', 'sessionId',
  'advertisingId', 'behaviouralProfile',
]);
const prohibitedLc = new Set(PROHIBITED_KEYS.map((k) => k.toLowerCase()));

const validateDiscoveryContext = (ctx) => {
  if (ctx === null || ctx === undefined) return true; // empty context is valid.
  if (typeof ctx !== 'object' || Array.isArray(ctx)) {
    throw new InvalidDiscoveryContextError('Context must be plain object or null');
  }
  if (Object.getPrototypeOf(ctx) !== Object.prototype && Object.getPrototypeOf(ctx) !== null) {
    throw new InvalidDiscoveryContextError('Context must be plain object');
  }
  for (const k of Object.keys(ctx)) {
    if (prohibitedLc.has(k.toLowerCase())) {
      throw new InvalidDiscoveryContextError(`Context contains prohibited key '${k}'`);
    }
  }
  // Shape-check known keys when present.
  if ('authenticated' in ctx && typeof ctx.authenticated !== 'boolean') {
    throw new InvalidDiscoveryContextError('authenticated must be boolean');
  }
  if ('permissions' in ctx && !Array.isArray(ctx.permissions)) {
    throw new InvalidDiscoveryContextError('permissions must be array');
  }
  if ('activeFeatureFlags' in ctx && !Array.isArray(ctx.activeFeatureFlags)) {
    throw new InvalidDiscoveryContextError('activeFeatureFlags must be array');
  }
  return true;
};

const freezeContext = (ctx) => {
  validateDiscoveryContext(ctx);
  return Object.freeze({ ...(ctx || {}) });
};

export { validateDiscoveryContext, freezeContext, PROHIBITED_KEYS };
